<template>
    <el-row :gutter="20">
        <el-col :span="4" class="colleft">
            <div class="toptitle">账号安全</div>
            <div style="height: 20px;background-color: #ffff;width: 100%;"></div>
            <el-menu :default-active="defaultIndex" class="el-menu-vertical-demo" @select="handleSelect"
                background-color="#FFFFFF" text-color="#000000" active-text-color="#52536f">

                <el-menu-item index="1">
                    <i class="el-icon-lx-warn"></i>
                    <span slot="title">黑号查询</span>
                </el-menu-item>
                <el-menu-item index="2">
                    <i class="el-icon-lx-mobile"></i>
                    <span slot="title">账号验证</span>
                </el-menu-item>
            </el-menu>

        </el-col>
        <el-col :span="20" >
            <el-card shadow="always" class="colright"  style="padding: 30px;min-height: 800px;">
                <div v-if="page == '1'" style="height: 600px;">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="游戏账号/手机号:">
                            <el-input v-model="formInline.user" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button round type="danger" @click="onSubmit" style="font-size: 14px;width: 80px;">查
                                询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="el-line-h"></div>
                    <div class="subtitle">黑号公示</div>
                    <el-table :data="tableData" style="width: 100%" size="medium">
                        <el-table-column prop="name" label="姓名" width="400">
                        </el-table-column>
                        <el-table-column prop="accounts" label="账号" width="400">
                        </el-table-column>
                        <el-table-column prop="game" label="游戏">
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="page == '2'"></div>

            </el-card>

        </el-col>

    </el-row>

</template>

<script>

import bus from "../common/bus.js";
import accounts from '../common/accounts.js';

export default {

    data() {
        return {
            defaultIndex: '1',
            page: '1',
            formInline: {
                user: ''
            },
            tableData: [{
                name: '刘**',
                accounts: '****8371',
                game: '王者荣耀',

            }, {
                name: '王*',
                accounts: '****4131',
                game: '王者荣耀',
            }, {
                name: '马*',
                accounts: '****4340',
                game: '王者荣耀',
            }, {
                name: '赵**',
                accounts: '****1218',
                game: '王者荣耀',
            }, {
                name: '李*',
                accounts: '****17861',
                game: '穿越火线',
            }]


        };
    },
    components: {

    },
    computed: {

    },
    created() {
        if (!accounts.UserID()) {
            this.$router.push('/login');
        }
    },
    watch: {
        // 监听路由对象中的查询参数部分
        '$route.query': {
            immediate: true, // 启用组件实例化时立即触发
            handler(newQuery, oldQuery) {
                // 这里处理查询参数变化的逻辑
                console.log('查询参数变化了:', newQuery, oldQuery);
                let index = this.$route.query.index;
                if (index) {
                    this.page = index;
                    this.defaultIndex = index;
                }
                console.log(index);
                // 例如，你可以在这里根据查询参数重新获取数据
            }

        }
    },
    mounted() {

    },
    deactivated() {

        bus.$off("collapse", this.handleBus);
    },
    methods: {
        handleSelect(key, keyPath) {
            this.page = key;
        },
        onSubmit() {
            console.log('submit!');
        }
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;

}

.colright {
    padding: 30px;
}

.subtitle {
    font-size: 16px;
    line-height: 40px;
    font-weight: 400;

}


.colleft {

    border-radius: 5px !important;
    height: 100%;
    background-color: #ff8800;
    border: 2px solid #ff8800;
    box-shadow: 2px 2px 2px 2px #d7d7d7;
    padding: 0px !important;
    padding-bottom: 20px !important;

}

.toptitle {
    text-align: center;
    font-size: 22px;
    margin-top: 20px;
    font-weight: 600px;
    color: #ffffff;
    height: 50px;
}

.el-menu-vertical-demo {
    margin-top: 0px;
}

.el-menu-item.is-active {
    border-bottom: 3px solid #52536f;
    background-color: #52536f !important;
    color: #ffffff !important;
    border-bottom: 0px solid #52536f;
}

.menutitle.is-active {
    border-bottom: 3px solid #52536f;
    background-color: #52536f !important;
    color: #ffffff !important;
    border-bottom: 0px solid #52536f;
}

.el-menu-item {
    font-size: 20px;
    color: #737373;
}

.el-icon-news {
    font-size: 20px;
    color: #737373;
}

.submenu {
    font-size: 20px;
    color: #737373;
}

.el-table {
    font-size: 16px;
    color: #474747;
}

/deep/.el-form-item__label {
    font-size: 18px !important;
}
</style>
